import { makeStyles } from '@mui/styles';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import {
    BRAND_MODAL_ACCENT_CHIP_BG,
    BRAND_MODAL_ACCENT_CHIP_BORDER,
} from '../../pages/BrandDashboard/brandDashboardTokens';

export const useStyles = (shouldDisable: boolean, themeStyle: ColorScheme, brandForm = false) =>
    makeStyles({
        root: {
            '& .MuiAutocomplete-popupIndicator': {
                display: 'none',
            },
            '& .MuiChip-root': {
                backgroundColor: brandForm ? BRAND_MODAL_ACCENT_CHIP_BG : theme[themeStyle].highlight,
                ...(brandForm ? { border: `1px solid ${BRAND_MODAL_ACCENT_CHIP_BORDER}` } : {}),

                '& .MuiChip-deleteIcon': {
                    color: brandForm ? 'rgba(255,255,255,0.65)' : theme[themeStyle].black,
                },
            },
            '& .MuiAutocomplete-option[data-focus="true"]': {
                backgroundColor: 'transparent',
            },
            '& .MuiAutocomplete-input': {
                color: theme[themeStyle].lightWhite, // Change text color to white
                '&::selection': {
                    backgroundColor: 'transparent', // Remove text highlight
                },
            },
            '& .MuiInputBase-root-MuiFilledInput-root': {
                color: 'white',
            },
            '& .MuiChip-label': {
                color: brandForm ? 'rgba(242,242,246,0.95)' : theme[themeStyle].black, // Change the limit tag text color (you can use any color here)
                fontFamily: FONT_ENUM.REGULAR_HEADER, // Change the font family (you can use any desired font family here)
                fontSize: '14px', // Change the font size (you can use any desired font size here)
                ...(brandForm ? { textTransform: 'capitalize' as const } : {}),
            },
            '& .MuiAutocomplete-tag': {
                fontSize: '14px', // Change the font size (you can use any desired font size here)
                fontWeight: 'normal', // Change the font weight (you can use 'bold', 'normal', etc.)
                fontStyle: 'normal', // Change the font style (you can use 'normal', 'italic', 'oblique', etc.)
                color: theme[themeStyle].lightWhite,
                padding: '2px 8px',
            },
            '& .MuiAutocomplete-inputRoot': brandForm
                ? {
                      border: 'none',
                      borderRadius: '12px',
                      backgroundColor: 'transparent',
                      boxSizing: 'border-box',
                      maxWidth: '100%',
                      overflow: 'hidden',
                  }
                : {
                      border: `1px solid ${theme[themeStyle].form_gray}`,
                      borderRadius: '10px',
                      '&.Mui-focused': {
                          borderColor: theme[themeStyle].highlight,
                      },
                  },
            '& .Mui-focused .MuiAutocomplete-inputRoot': brandForm
                ? {}
                : {
                      borderColor: theme[themeStyle].highlight,
                  },
        },
        inputRoot: {
            padding: brandForm ? '12px 16px' : '18px',
            boxSizing: 'border-box',
            // Apply padding inside the TextField for the chips
        },
        noOptions: {
            color: theme[themeStyle].lightWhite,
            backgroundColor: shouldDisable ? theme[themeStyle].form_gray : 'transparent',
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            display: !shouldDisable ? 'none' : 'inherit',
        },
    });
